<template>
  <div style="max-width: 600px; margin: 0 auto;">
    <canvas ref="chart" style="min-height:320px;max-height:380px;"></canvas>
  </div>
</template>

<script>
import { onMounted, ref, watch } from 'vue'
import Chart from 'chart.js/auto'

export default {
  props: {
    executados: { type: Number, default: 0 },
    contratados: { type: Number, default: 0 },
    excedentes: { type: Number, default: 0 }
  },
  setup(props) {
    const chart = ref(null)
    let chartInstance = null

    const renderChart = () => {
      if (chartInstance) {
        chartInstance.destroy()
      }
      chartInstance = new Chart(chart.value, {
        type: 'pie',
        data: {
          labels: ['Executados', 'Contratados', 'Excedentes'],
          datasets: [
            {
              data: [
                props.executados || 0,
                props.contratados || 0,
                props.excedentes || 0
              ],
              backgroundColor: ['#4caf50', '#2196f3', '#f44336']
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true, position: 'bottom' }
          }
        }
      })
    }

    onMounted(() => {
      renderChart()
      // Ajuste de altura para um tamanho maior
      if (chart.value) {
        chart.value.parentNode.style.height = '340px'
      }
    })
    watch(() => [props.executados, props.contratados, props.excedentes], renderChart)

    return { chart }
  }
}
</script>
